import { render } from "./MinipayAuthorizationFailed.vue?vue&type=template&id=14a5af82&scoped=true&ts=true"
import script from "./MinipayAuthorizationFailed.vue?vue&type=script&lang=ts"
export * from "./MinipayAuthorizationFailed.vue?vue&type=script&lang=ts"

import "./MinipayAuthorizationFailed.vue?vue&type=style&index=0&id=14a5af82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a5af82"],['__file',"src/components/sell/MinipayAuthorizationFailed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "14a5af82"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('14a5af82', __exports__)) {
    api.reload('14a5af82', __exports__)
  }
  
  module.hot.accept("./MinipayAuthorizationFailed.vue?vue&type=template&id=14a5af82&scoped=true&ts=true", () => {
    api.rerender('14a5af82', render)
  })

}


export default __exports__